/**
 *
 * Asynchronously loads the component for EkycPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
